import dayjs from 'dayjs';
import { isNumericString, getAdvanceKey, isObject } from '..';
import { DATE_FORMATS } from '../../constants/date-constants';
import { getSelectedAdvanceInputFilter, mapQueryStringToFilterObject } from '../filters-util';
import { FILTER_DISPLAY_VALUE } from '../../constants/filters-constants';

const getChipObject = ({ chipInfo, key, value }) => {
  const { type = '', displayName = '', options: chipOptions, mode = 'multiple', setAsSlug = false } = chipInfo[key];
  const options = isObject(chipOptions) ? chipOptions?.[''] || [] : chipOptions || [];
  let dropdownValue = value;
  switch (type) {
    case 'advance_input':
      return { chipValue: FILTER_DISPLAY_VALUE(value)?.[getAdvanceKey(key)], chipName: displayName, seperator: ', ' };
    case 'input':
      return { chipValue: value, chipName: displayName, seperator: ', ' };
    case 'date':
      return {
        chipValue: dayjs(value).format(DATE_FORMATS.dayMonthYearFilters),
        chipName: displayName,
        seperator: ' - ',
      };
    case 'dropdown':
      if (isNumericString(value)) dropdownValue = parseInt(value);
      return {
        chipValue:
          mode === 'multiple'
            ? options
                ?.filter((item) => value === (setAsSlug ? item?.slug : String(item?.id)))
                ?.map((item) => item?.name)
                .join(', ')
            : options?.find((item) => (setAsSlug ? item?.slug === dropdownValue : item?.id === dropdownValue))?.name,
        chipName: displayName,
        seperator: ', ',
      };
    default:
      return '';
  }
};

const getChipInfo = (filtersList, filtersObject) => {
  const chipInfo = {};
  filtersList?.map((filter) => {
    if (filter.type === 'date' || filter.type === 'range' || filter.type === 'boolean-range') {
      if (filter?.keys || filter?.customKeys) {
        chipInfo[filter?.customKeys?.[0] ?? `q[${filter?.keys[0]}_gteq]`] = {
          type: filter?.type,
          displayName: filter?.placeholder || filter?.label,
        };
        chipInfo[filter?.customKeys?.[1] ?? `q[${filter?.keys[1]}_lteq]`] = {
          type: filter?.type,
          displayName: filter?.placeholder || filter?.label,
        };
      } else {
        if (filter?.type) {
          chipInfo[`q[${filter?.key}_gteq]`] = {
            type: filter?.type,
            displayName: filter?.placeholder || filter?.label,
          };
          chipInfo[`q[${filter?.key}_lteq]`] = {
            type: filter?.type,
            displayName: filter?.placeholder || filter?.label,
          };
        }

        chipInfo[`q[${filter?.key}_gt${filter.type !== 'boolean-range' ? 'eq' : ''}]`] = {
          type: filter?.type,
          displayName: filter?.placeholder || filter?.label,
          ...(filter.type === 'boolean-range' && { options: filter?.options }),
        };
        chipInfo[`f[${filter?.key}][lte]`] = {
          type: filter?.type,
          displayName: filter?.placeholder || filter?.label,
          ...(filter.type === 'boolean-range' && { options: filter?.options }),
        };
      }
    } else if (filter.type === 'advance_input') {
      const selectedFilter = getSelectedAdvanceInputFilter(filtersObject, filter);
      if (selectedFilter?.key) {
        chipInfo[selectedFilter?.key] = {
          type: filter?.type,
          displayName: filter?.placeholder || filter?.label,
          options: filter?.options,
          mode: filter?.mode,
          setAsSlug: filter?.setAsSlug,
        };
      }
    } else {
      chipInfo[filter?.key] = {
        type: filter?.type,
        displayName: filter?.placeholder || filter?.label,
        options: filter?.options,
        mode: filter?.mode,
        setAsSlug: filter?.setAsSlug,
      };
    }
  });
  return chipInfo;
};

export const handleFilterChips = ({ location, filtersList, filtersObject }) => {
  const chipInfo = getChipInfo(filtersList, filtersObject);
  const filterCh = [];
  const obj = {};
  const chipMap = {};

  mapQueryStringToFilterObject(location.search, (key, value) => {
    if (!chipInfo[key]) return;
    const chipObject = getChipObject({ chipInfo, key, value });

    if (!obj[chipObject.chipName]) {
      chipMap[chipObject.chipName] = key;
      obj[chipObject.chipName] = `${chipObject.chipValue ?? ''}`;
    } else {
      const existingValues = obj[chipObject.chipName].split(chipObject.seperator).map((val) => val.trim());
      const newValue = `${chipObject.chipValue}`;

      existingValues.push(newValue);

      obj[chipObject.chipName] = existingValues.join(chipObject.seperator);
    }
  });

  Object.keys(obj).forEach((element) => {
    const space = '\n';
    if (obj[element]) {
      filterCh.push({
        title: (
          <>
            <span style={{ color: 'var(--user-main-text-2)' }}>
              {element}:{space}
            </span>
            <span style={{ fontWeight: 'var(--ant-font-weight-strong)' }}>{obj[element]}</span>
          </>
        ),
        label: element,
        searchKey: chipMap[element],
        searchValue: obj[element],
        location,
      });
    }
  });
  return filterCh;
};
